module.exports = __webpack_public_path__ + "static/media/tooltip-hover.f865fe3e.svg";